module.exports = __webpack_public_path__ + "img/img_webinar4.65477275.jpg";